import React from "react";
import { TimePicker } from "@mui/x-date-pickers";
import { datePickerSx } from "lib/muiStyle/muiStyle";
import Label from "../Label/Label";
import HelperMessage from "components/Input/HelperMessage/HelperMessage";
import c from "lib/style/colorVar.scss";
import dayjs from "dayjs";

const Timepicker = ({
  label,
  mandatory,
  type,
  errorMessage,
  noErrorMessage,
  onchangeFn,
  onfocusFn,
  onblurFn,
  value,
  defaultValue,
  sxParams,
  disabled,
  readonly,
  divStyle,
}) => {
  const { datepickerFocus, datepickerError } = sxParams;
  return (
    <div onFocus={onfocusFn} onBlur={onblurFn} style={divStyle}>
      <Label label={label} mandatory={mandatory} />
      <TimePicker
        slotProps={{
          textField: {
            size: "small",
            style: disabled ? { background: c.disabledFieldBg } : {},
            readOnly: readonly,
          },
        }}
        value={value && dayjs(value)}
        defaultValue={defaultValue && dayjs(defaultValue)}
        onChange={(e) => onchangeFn(e, type)}
        views={["hours", "minutes", "seconds"]}
        ampm={false}
        sx={() => datePickerSx(datepickerFocus, datepickerError)}
        disabled={disabled}
      />
      {!noErrorMessage && (
        <HelperMessage message={datepickerError && errorMessage} />
      )}
    </div>
  );
};

export default React.memo(Timepicker);
